export enum LocationPaths {
  Auth = '/auth',
  SignIn = '/sign-in',
  PasswordResetRequest = '/password-reset-request',
  NotFound = '/not-found',
  Onboarding = '/onboarding',
  DownloadApp = '/download-app',
  VideoCalls = '/video-calls',
  HealthQuestionnaire = '/health-questionnaire',
  KeggNotEligible = '/kegg-not-eligible',
  Questionnaire = '/questionnaire/:surveyKind',
  InsuranceQuestionnaireV2 = '/insurance-questionnaire',
  FreeVideoCall = '/free-video-call',
  ScheduleCall = '/schedule-call',
  AddressState = '/address-state',
  LegacyOwnSensor = '/own-sensor/*',
  OwnSensorV2 = '/own-sensor-v2',
  Checkout = 'checkout/:product',
  PaidVideoCalls = '/video-calls/paid',
  Partner = '/partner',
  Uhc = '/uhc',
  MfaChallenge = '/auth/mfa',
  Upgrade = '/upgrade'
}

export enum AuthPath {
  Confirm = 'confirm/:token'
}

export enum OnboardingPath {
  SetPassword = 'set-password',
  Start = 'start',
  Goal = 'goal',
  BasicInformation = 'basic-information',
  SelectCoachingTeam = 'select-coaching-team',
  SelectCoach = 'select-coach',
  ScheduleCall = 'schedule-call',
  SelectStressCoach = 'select-stress-coach',
  ScheduleStressCall = 'schedule-stress-call',
  PreSchedulingInsuranceProvider = 'insurance-provider-pre-scheduling',
  InsuranceProvider = 'insurance-provider',
  State = 'state',
  PostSchedulingInsurance = 'post-scheduling-insurance',
  InsuranceIntro = 'insurance-intro',
  InsuranceCheck = 'insurance-check',
  Insurance = 'insurance',
  HeardAboutNutrisense = 'heard-about-nutrisense',
  FreeCallInfo = 'free-call-info',
  PaidCallInfo = 'paid-call-info',
  Confirmation = 'confirmation',
  UpsellOffer = 'upsell-offer',
  UpsellOfferConfirmation = 'upsell-confirmation',
  UpsellSelectCoach = 'upsell-select-coach',
  UpsellScheduleCall = 'upsell-schedule-call',
  UpsellCheckout = 'upsell-checkout',
  UpsellMicrobiome = 'upsell-microbiome',
  AppointmentOfferConfirmation = 'upsell-appointment-confirmation'
}

export enum PartnerPath {
  SignUp = 'sign-up',
  SignIn = 'sign-in',
  CodeRedemption = 'code-redemption',
  SteloEligibility = 'stelo-eligibility',
  Address = 'address',
  ClaimOffer = 'claim-offer',
  ScheduleCall = 'schedule-call',
  CompleteAccount = 'complete-account',
  Confirmed = 'confirmed',
  Ineligible = 'ineligible',
  Checkout = 'checkout',
  ProgramEligibility = 'program-eligibility',
  ChooseInsuranceProvider = 'choose-insurance-provider',
  ChoosePolicyHolder = 'choose-policy-holder',
  InsuranceInformation = 'insurance-information'
}

export enum VideoCallsPath {
  MfpCreditIntro = 'mfp-credit',
  ChoosePrimaryHealthGoal = 'choose-primary-health-goal',
  ChooseSecondaryHealthGoal = 'choose-secondary-health-goal',
  InsurancePrep = 'insurance-prep',
  Insurance = 'insurance',
  EmailAddress = 'email-address',
  KeggCallConfirmed = 'kegg-call-confirmed',
  SignUp = 'sign-up',
  State = 'state',
  AddressForm = 'address-form',
  Completed = 'completed',
  IntegrateDexcomAccount = 'integrate-dexcom-account',
  AddPaymentMethod = 'add-payment-method',
  BenefitsCheck = 'benefits-check',
  InsuranceQuestionnaire = 'questionnaire/insurance',
  FreeVideoCall = 'free-video-call',
  ScheduleCall = 'schedule-call',
  AddAppointmentAgenda = 'add-appointment-agenda',
  VerifyCoverage = 'verify-coverage',
  HeardAboutNutrisense = 'heard-about-nutrisense',
  Dashboard = 'dashboard',
  ReviewAppointment = 'review-appointment',
  Chat = 'chat',
  SignIn = 'sign-in',
  WeightLossExperienceStart = 'weight-loss-experience/start',
  WeightLossExperienceCompleted = 'weight-loss-experience/completed',
  WeightLossExperiencePlan = 'weight-loss-experience/plan',
  StressManagementStart = 'stress-management/start',
  StressManagementScheduleCall = 'stress-management/schedule-call',
  StressManagementCheckout = 'stress-management/checkout',
  StressManagementUpsell = 'stress-management/offer',
  AppointmentConfirmed = 'appointment-confirmed',
  UpsellLoader = 'upsell-loader',
  LabPanels = 'lab-panels',
  Microbiome = 'microbiome',
  Checkout = 'checkout',
  DexcomCallback = 'dexcom-callback'
}

export enum PaidVideoCallsPath {
  UserInfo = 'user-info',
  State = 'state',
  ScheduleCall = 'schedule-call',
  Checkout = 'checkout',
  Completed = 'completed',
  AppointmentConfirmed = 'appointment-confirmed',
  IntegrateDexcomAccount = 'integrate-dexcom-account'
}

export enum OwnSensorV2Path {
  LoadingScreen = 'loading-screen',
  ChooseSensor = 'choose-sensor',
  LibreIndirectSyncConfirmation = 'libre-indirect-sync-confirmation',
  WhatBringsYou = 'what-brings-you',
  Quote1 = 'quote-1',
  TrackedGlucose = 'tracked-glucose',
  AppOverview = 'app-overview',
  Height = 'height',
  Weight = 'weight',
  WellnessSnapshot = 'wellness-snapshot',
  GoalWeight = 'goal-weight',
  Quote2 = 'quote-2',
  ChronicConditions = 'chronic-conditions',
  FamilyDiabetes = 'family-diabetes',
  Quote3 = 'quote-3',
  PreparingYourProgram = 'preparing-your-program',
  CreateAccount = 'create-account',
  PlanSelection = 'plan-selection',
  Checkout = 'checkout/:product',
  SetPassword = 'set-password'
}

export enum UhcPath {
  Auth = 'auth',
  Error = 'error/:reason',
  SignUp = 'sign-up',
  SignIn = 'sign-in',
  PhoneNumber = 'phone-number',
  ProgramEligibility = 'program-eligibility',
  Questionnaire = 'questionnaire/:surveyKind',
  Goal = 'goal',
  ConfirmPurchase = 'confirm-purchase',
  ScheduleCall = 'schedule-call',
  CoachingGoalsStart = 'coaching-goals/start',
  Completed = 'completed'
}

export interface LocationState {
  from: LocationStateFrom
}

export interface LocationStateFrom {
  pathname: LocationPaths
}

export enum SearchParams {
  ChatProviderType = 'chatProviderType',
  Clinic = 'clinic',
  CoachId = 'coachId',
  SelectedCoachId = 'selectedCoachId',
  ConversationId = 'conversationId',
  DateOfBirth = 'dateOfBirth',
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  PhoneNumber = 'phoneNumber',
  PhiConsent = 'phi_consent',
  Sex = 'sex',
  ForceAllowCaptcha = 'force_allow_captcha',
  Outcome = 'outcome',
  Partner = 'partner',
  PartnerProduct = 'partnerProduct',
  PromoCode = 'promoCode',
  AppliedPromoCode = 'appliedPromoCode',
  PendingAppointmentId = 'pendingAppointmentId',
  PreviousSlotNotAvailable = 'previousSlotNotAvailable',
  SchedulingSource = 'source',
  SensorOptions = 'sensorOptions',
  SurveyFallbackUrl = 'fallback',
  SurveyKind = 'survey_kind',
  Insurance = 'insurance',
  TargetPath = 'target_path',
  Token = 'token',
  WebsiteSourceUrl = 'websiteSourceUrl',
  ExistingUserEmail = 'existingUserEmail',
  AppointmentKind = 'appointmentKind',
  AppointmentChargeKind = 'appointmentChargeKind',
  StressManagementSource = 'source',
  Product = 'product',
  TestGroup = 'testGroup',
  InsurancePlan = 'insurancePlan',
  // Standalone Video Calls Customization Params
  FlowKind = 'flowKind',
  ShowRecurring = 'showRecurring',
  HideOnboarding = 'hideOnboarding',
  DisableFakeSlots = 'disableFakeSlots',
  BypassCreditCard = 'bypassCreditCard',
  DaysOffset = 'daysOffset',
  AvailabilityWeeks = 'availabilityWeeks',
  MaestroTest = 'maestroTest',
  ForceKeggFlow = 'forceKeggFlow'
}
